import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor } from '../../Theming';
import { useTranslation } from 'react-i18next';
import house from '../../Assets/TreePlanting/houseBlack.png';
import money from '../../Assets/TreePlanting/moneyBlack.png';
import trees from '../../Assets/TreePlanting/treesBlack.png';

const Container = styled.section`
  margin: 72px 0 0 0;

  ${mobileMediaQuery} {
    margin: 32px 0 0 0;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: space-evenly;
`;

const InnerContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-right: 24px;

  ${mobileMediaQuery} {
    margin-right: 8px;
  }

  &:last-child {
    margin-right: 0;
  }

  [dir='rtl'] & {
    &:first-child {
      margin-right: 0;
    }

    &:last-child {
      margin-right: 24px;

      ${mobileMediaQuery} {
        margin-right: 8px;
      }
    }
  }
`;

const IconContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background-color: ${themeColor('greyBackground')};
  border-radius: 20px;
  height: 180px;

  ${mobileMediaQuery} {
    border-radius: 7px;
    height: 55px;
  }
`;

const Icon = styled.img`
  max-width: 91px;
  max-height: 100px;
  margin: 20px 0 20px 0;
  ${mobileMediaQuery} {
    max-width: 23px;
    max-height: 25px;
    margin: 10px 0 15px 0;
  }
`;

const Description = styled.p`
  margin: 24px 0 0 0;
  font-size: 16px;
  font-family: SuisseIntl-Regular;

  [dir='rtl'] & {
    text-align: right;
  }

  ${mobileMediaQuery} {
    font-size: 12px;
    margin-top: 12px;
  }
`;

const Header = styled.h2`
  margin: 0 0 32px 0;
  padding: 0;
  font-family: SuisseIntl-Medium;
  font-weight: normal;
  text-align: center;
  font-size: 32px;

  ${mobileMediaQuery} {
    margin: 0 0 8px 0;
    font-size: 16px;
    line-height: 20px;
  }
`;

const HowItWorks = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header>{t('treePlantingV2.howDoesItWork.heading')}</Header>
      <ContentContainer>
        <InnerContentContainer>
          <IconContainer>
            <Icon src={house} />
          </IconContainer>
          <Description>
            {t('treePlantingV2.howDoesItWork.descriptions.part1')}
          </Description>
        </InnerContentContainer>

        <InnerContentContainer>
          <IconContainer>
            <Icon src={money} />
          </IconContainer>
          <Description>
            {t('treePlantingV2.howDoesItWork.descriptions.part2')}
          </Description>
        </InnerContentContainer>

        <InnerContentContainer>
          <IconContainer>
            <Icon src={trees} />
          </IconContainer>
          <Description>
            {t('treePlantingV2.howDoesItWork.descriptions.part3')}
          </Description>
        </InnerContentContainer>
      </ContentContainer>
    </Container>
  );
};

export default HowItWorks;
